import'./gender-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class GenderScreen
 * @implements {ng.IComponentOptions}
 */
export class GenderScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: Function = GenderScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./gender-screen.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
    options: '=',
    isLast: '@',
    isFirst: '@',
  }
}

/**
 * GenderScreen - Controller
 *
 * @export
 * @class GenderScreenController
 */
export class GenderScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', 'AudioManager', 'ProgressManager', 'TrackingManager']
  public options
  public isLast
  public isFirst
  public navReady

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public AudioManager: any, public ProgressManager: any, public TrackingManager: any) {
    this.$log = $log.getInstance('GenderScreen', false);
    this.$log.debug('constructor')

    /*this.AngularServices.$rootScope.$on('progress:gender', (event, data) => {
      this.AppServices.HeroManager.setGender(data.gender)
    })*/
  }

  public selectGender(gender:string) {
    // this.AppServices.HeroManager.setGender(gender)
    // this.onNext()
  }

  public onNext() {
    this.AppServices.ScreenManager.performNavigation('next', this.options)
  }

  public onPrevious() {
    this.AppServices.ScreenManager.performNavigation('previous', this.options)
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');
    let items = document.querySelectorAll('.gender-screen__model')
    this.AngularServices.$animate.addClass(angular.element(items[0]), 'bounceInLeft');
    this.AngularServices.$animate.addClass(angular.element(items[1]), 'bounceInRight');
    this.AngularServices.$animate.removeClass(angular.element(items[0]), 'bounceOutLeft');
    this.AngularServices.$animate.removeClass(angular.element(items[1]), 'bounceOutRight');
  }
  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
  }

  public onExitStart() {
    this.$log.debug("onExitStart")
    let items = document.querySelectorAll('.gender-screen__model')
    this.AngularServices.$animate.removeClass(angular.element(items[0]), 'bounceInLeft');
    this.AngularServices.$animate.removeClass(angular.element(items[1]), 'bounceInRight');
    this.AngularServices.$animate.addClass(angular.element(items[0]), 'bounceOutLeft');
    this.AngularServices.$animate.addClass(angular.element(items[1]), 'bounceOutRight');
    this.options.navReady = false
    let gender = this.AppServices.HeroManager.selectedGender
    if (gender){
      this.ProgressManager.setGender(gender)
    } else {
      this.ProgressManager.setGender('female')
    }
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")
    // if (!this.TrackingManager.genderIsSet && this.TrackingManager.heroGender !== this.ProgressManager.getGender()){
      this.TrackingManager.trackGender(this.ProgressManager.getGender())
      this.TrackingManager.heroGender = this.ProgressManager.getGender()
    // }
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
    this.options.isLast = this.isLast;
    this.options.isFirst = this.isFirst;
    this.options.$element = this.$element;
    this.options.$ctrl = this;
    this.options.previousDisabled = true
    this.AppServices.ScreenManager.genderScreenOptions = this.options
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/gender-screen/gender-screen.ts
 **/